export enum ToastEmitterOptionsType {
    success = "success", info = "info", warning = "warning", error = "error", default = "default"
}